export default __webpack_public_path__ + "static/media/avatar_138.e63148e3.png";